// Mirrors the backend's WebsiteUrlValidator - keep both in sync.
// Lets non-technical users type "www.example.com" instead of requiring
// "https://www.example.com", while still rejecting non-http(s) schemes
// (javascript:, data:, ...) and bare words with no real host ("http://bla").
const HOST_PATTERN =
  /^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,24}$/;

export function normalizeWebsiteUrl(rawUrl) {
  if (!rawUrl) return null;
  const trimmed = rawUrl.trim();
  if (!trimmed || /\s/.test(trimmed)) return null;

  let candidate;
  try {
    candidate = new URL(trimmed);
  } catch {
    try {
      candidate = new URL(`https://${trimmed}`);
    } catch {
      return null;
    }
  }

  if (candidate.protocol !== "http:" && candidate.protocol !== "https:") {
    return null;
  }

  if (!HOST_PATTERN.test(candidate.hostname)) {
    return null;
  }

  return candidate.href;
}

export function isValidWebsiteUrl(rawUrl) {
  return normalizeWebsiteUrl(rawUrl) !== null;
}
